import Vue from 'vue';
import VueRouter from 'vue-router';

import DashboardMain from './dashboard-main.vue';
import MainPage from './main.vue';
import Account from './pages/Account.vue';
import Events from './pages/Events.vue';
import Locations from './pages/Locations.vue';
import Messages from './pages/Messages.vue';
import Promotions from './pages/Promotions.vue';
import PromotionsEditorCreate from './pages/promotions/EditOrCreate.vue';
import PaymentResult from './pages/payment/Result.vue'

Vue.use(VueRouter);

export default [
    {
        path: '/:locale?/dashboard', // locale is optional
        component: DashboardMain,
        children: [
            { path: '', component: MainPage, name: 'dashboard', meta: { title: 'Dashboard' } },
            { path: 'account', component: Account, name: 'account', meta: { title: 'Account' } },
            { path: 'events', component: Events, name: 'events', meta: { title: 'Events' } },
            { path: 'locations', component: Locations, name: 'locations', meta: { title: 'Locations' } },
            { path: 'messages', component: Messages, name: 'messages', meta: { title: 'Messages' } },
            { path: 'promotions', component: Promotions, name: 'promotions', meta: { title: 'Promotions' } },
            {
                path: 'promotions/add',
                name: 'promotions.add',
                component: PromotionsEditorCreate,
                meta: { title: 'Add' },
                props: route => ({ mode: 'add' }),
            },
            {
                path: 'promotions/edit/:uuid',
                name: 'promotions.edit',
                component: PromotionsEditorCreate,
                meta: { title: 'Edit' },
                props: route => ({ mode: 'edit', uuid: route.params.uuid }),
            },
            { path: 'payment/result', component: PaymentResult, name: 'payment', meta: { title: 'Payment' } },


        ],
    },
];